<template>
  <!-- 货源信息 -->
  <div class="layout">
    <Layout>
      <!-- 头 -->
      <Header>
        <Menu theme="light" mode="horizontal" active-name="1">
          <!-- <div class="layout-logo">
            <a href="/"> <img src="../assets/logocss.png" alt="" /></a>
          </div> -->
          <a href="/" class="layout-logo" style="display: flex;align-items: center;margin-left: 30px;">
                  <img src="../assets/freight.png" alt="" />
                  <div style="color:#666;font-size:25px;font-weight: bold;letter-spacing: 1px;margin-left: 10px;font-family: inherit;">巩义市荣胜工程检测技术有限公司</div>
          </a>
          <div class="layout-nav">
            <MenuItem
              style="font-size: 18px !important"
              name="1"
              to="/sourceInformation"
            >
              货源信息
            </MenuItem>
            <MenuItem
              to="/vehicleInformation"
              style="font-size: 18px !important"
              name="2"
            >
              车源信息
            </MenuItem>
            <MenuItem
              to="/complaintPublicity"
              style="font-size: 18px !important"
              name="3"
            >
              评价公示
            </MenuItem>
            <MenuItem
              to="/evaluationPublicity"
              style="font-size: 18px !important"
              name="4"
            >
              投诉公示
            </MenuItem>
            <Submenu name="5">
              <template slot="title"
                ><span style="font-size: 18px !important">联系客服</span>
              </template>
              <MenuItem
                to="/customerServiceContact"
                style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                "
                name="2-1"
                >投诉建议</MenuItem
              >
              <MenuItem
                to="/contactUs"
                style="
                  font-size: 15px !important;
                  padding-left: 35px !important;
                "
                name="2-2"
                >联系我们</MenuItem
              >
            </Submenu>
            <MenuItem
            to=""
            target="_blank"
              style="font-size: 18px !important"
              name="6"
            >
              登录
            </MenuItem>
          </div>
        </Menu>
      </Header>
      <div class="Header-img"></div>
      <!-- 中 -->
      <Content>
        <div style="display: flex; justify-content: center">
          <div></div>
          <div>
            <div class="search">
              <div style="display: flex">
                <div style="display: flex">
                  <div class="search-span">装货地址</div>
                  <div>
                    <Cascader
                      size="large"
                      style="width: 240px"
                      :data="regionData"
                      @on-change="getStartArea"
                      v-model="searchForm.begin"
                      clearable
                    ></Cascader>
                  </div>
                </div>
                <div style="margin-left: 20px; display: flex">
                  <div>
                    <div class="search-span2">卸货地址</div>
                  </div>
                  <div>
                    <Cascader
                      size="large"
                      style="width: 240px"
                      :data="regionData"
                      @on-change="getEndArea"
                      v-model="searchForm.end"
                      clearable
                    ></Cascader>
                  </div>
                </div>
                <div style="margin-left: 20px">
                  <Button
                    size="large"
                    style="
                      background-color: #19be6b !important;
                      color: #fff !important;
                      border: 0 !important;
                    "
                    icon="ios-search"
                    @click="handleSearch"
                    :loading="butLoading"
                    >查询</Button
                  >
                </div>
                <div class="Content-criteria" @click="clickCriteriaIcon">
                  更多筛选条件
                  <i
                    :class="
                      criteriaIcon == true
                        ? 'el-icon-caret-top'
                        : 'el-icon-caret-bottom'
                    "
                  ></i>
                </div>
              </div>
            </div>
            <div v-if="!criteriaIcon" class="search2">
              <div style="display: flex">
                <div style="display: flex">
                  <div class="search-span">装货时间</div>
                  <div>
                    <DatePicker
                      clearable
                      size="large"
                      placeholder="请选择日期"
                      style="width: 220px"
                      v-model="searchForm.startDate1"
                      @on-change="selectDateRange"
                      format="yyyy-MM-dd"
                    ></DatePicker>
                  </div>
                </div>
                <div style="margin-left: 20px; display: flex">
                  <div>
                    <div style="padding-top: 10px; margin-right: 15px">至</div>
                  </div>
                  <div>
                    <DatePicker
                      clearable
                      size="large"
                      placeholder="请选择日期"
                      style="width: 220px"
                      v-model="searchForm.endDate1"
                      format="yyyy-MM-dd"
                      @on-change="selectDateendDate"
                    ></DatePicker>
                  </div>
                </div>
                <div style="display: flex; margin-left: 60px">
                  <div class="search-span">货品名称</div>
                  <div>
                    <Input
                      size="large"
                      v-model="searchForm.goodSubType"
                      style="width: 260px"
                      clearable
                    ></Input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <!--  -->
        <div
          style="display: flex; justify-content: center; margin-bottom: 40px"
        >
          <!-- <div></div>
          <div style="display: flex; margin-left: 850px">
            <div>
              <Button size="large">按装货时间</Button>
            </div>
            <div style="margin-left: 10px">
              <Button size="large" type="primary">按发布时间</Button>
            </div>
          </div>
          <div></div> -->
        </div>
        <!--  -->
        <div
          style="display: flex; justify-content: center; margin-bottom: 40px"
        >
          <div></div>
          <div class="Content-tblo">
            <el-row>
              <el-col :span="24">
                <div class="Content-table">
                  <el-table
                    :data="tableData"
                    border
                    height="650"
                    style="width: 70vw"
                    :header-cell-style="{
                      background: '#eef1f6',
                      color: '#606266',
                    }"
                    ref="table"
                    @cell-mouse-enter="move"
                    @cell-mouse-leave="remove"
                  >
                    >

                    <el-table-column
                      align="center"
                      prop="createTime"
                      label="创建时间"
                      width="180"
                    >
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="beginAddress"
                      label="装货地址"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        {{
                          scope.row.beginProvinceName +
                          scope.row.beginCityName +
                          scope.row.beginAreaName
                        }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      align="center"
                      prop="endAddress"
                      label="卸货地址"
                      :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        {{
                          scope.row.endProvinceName +
                          scope.row.endCityName +
                          scope.row.endAreaName
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="goodSubType"
                      label="货品名称"
                    >
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="totalGoodWeight"
                      label="发布数量"
                    >
                    </el-table-column>
                    <el-table-column
                      align="center"
                      prop="pricingType"
                      label="报价方式"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.pricingType == "1" ? "按单价" : "按整单" }}
                      </template>
                    </el-table-column>

                    <el-table-column
                      align="center"
                      prop="useVehicleType"
                      label="运输方式"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.useVehicleType == "1" ? "整车" : "零担" }}
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
            <!-- <div>
              <i
                ><Icon
                  style="font-size: 100px; display: block; color: #cccccc"
                  type="ios-albums-outline"
              /></i>
              <p style="display: block; color: #cccccc">空空如也~</p>
            </div> -->
          </div>
          <div></div>
        </div>
      </Content>
      <!-- 尾 -->
      <Footer class="layout-footer-center">
        <div
          style="
            width: 100%;
            height: 100%;
            background-image: linear-gradient(#252c37, #1e252c);
          "
        >
          <div style="width: 100%; height: 50px"></div>

          <!-- 低 -->

          <div style="display: flex">
            <div class="Footer-text-left">畅运达网络货运平台欢迎您的加入！</div>
            <div class="Footer-text-right">
              <p class="Footer-text-title">巩义市荣胜工程检测技术有限公司</p>
              <!-- <p class="opt opt-let">
                <span class="title">帮助中心</span>
                <router-link class="a-link" :to="'/userGuide'">
                  用户指南
                </router-link>
              </p> -->
              <p class="opt opt-let">
                <span class="title">关于我们</span>
                <router-link class="a-link" :to="'/contactUs'">
                  联系我们
                </router-link>
              </p>
              <p class="opt opt-let2">
                <span style="margin-left: -1px" class="title">服务热线</span>
                <router-link class="a-link1" :to="'#'">
                  19939900789
                </router-link>
              </p>
            </div>
          </div>
          <!-- 线 -->
          <div class="Line">
            <div class="LineClik"></div>
          </div>
          <!-- 低 -->
          <div>
            <p style="line-height: 18px">
              <img
                src="../assets/hui.png"
                style="width: 18px; height: 18px; vertical-align: middle"
                alt=""
              />
              <a
                style="line-height: 18px; color: #ffffff"
                href="http://www.beian.gov.cn/portal/recordQuery?token=cc5dd992-aa8e-47e8-94b8-2c2e2feadf98"
                target="_blank"
                >豫公网安备41010099402-25001号</a
              >&emsp;
              <span style="color: #b4c1cd">增值电信业务经营许可证：</span>
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                style="line-height: 18px; color: #ffffff"
                target="_blank"
                >豫B2-20250468</a
              >
            </p>
            <p style="padding-bottom: 20px; color: #b4c1cd">
              © Copyright 2026
              <span
                ><a style="color: #ffffff" href="#">
                  巩义市荣胜工程检测技术有限公司
                </a></span
              >
              All Rights Reserved.
              <a
                style="color: #ffffff"
                href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank"
                >豫ICP备2025119886号</a
              >
            </p>
            <div>
              <div style="width: 100%; height: 10px"></div>
            </div>
          </div>
        </div>
      </Footer>
    </Layout>
  </div>
</template>
<script>
const regionData = require("../libs/region.json");
export default {
  data() {
    return {
      //地址筛选
      regionData: [],
      value1: 0,
      height: 0,
      one: false,
      criteriaIcon: true,
      searchForm: {
        begin: [],
        end: [],
        startDate: "",
        endDate: "",
        goodSubType: "",
        beginAreaCode: "",
        endAreaCode: "",
        startDate1: "",
        endDate1: "",
      },
      tableData: [],
      timer: null,
      butLoading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    // 拿到表格挂载后的真实DOM
    const table = this.$refs.table;
    // 拿到表格中承载数据的div元素
    const divData = table.bodyWrapper;
    // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
    this.timer = setInterval(() => {
      // 元素自增距离顶部1像素
      divData.scrollTop += 1;
      // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
      if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
        // 重置table距离顶部距离
        divData.scrollTop = 0;
      } else {
        if (divData.scrollTop == 130) {
          divData.scrollTop = 0;
        }
      }
    }, 50);
    setTimeout(() => {
      this.regionData = regionData;
    }, 100);
  },
  methods: {
    selectDateRange(val) {
      this.searchForm.startDate = val;
    },
    selectDateendDate(val) {
      this.searchForm.endDate = val;
    },
    init() {
      this.$axios({
        method: "post",
        url: "/freight/officialWebsiteData/sourceGoodsList",
        data: this.searchForm,
        transformRequest: [
          function (data) {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
          },
        ],
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        this.tableData = res.data.result;
      });
    },

    clickCriteriaIcon() {
      this.criteriaIcon = !this.criteriaIcon;
    },
    // 鼠标进入
    move() {
      clearInterval(this.timer);
    },
    // 鼠标移出
    remove() {
      const table = this.$refs.table;
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      this.timer = setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 1;
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          // 重置table距离顶部距离
          divData.scrollTop = 0;
        } else {
          if (divData.scrollTop == 130) {
            divData.scrollTop = 0;
          }
        }
      }, 50);
    },
    // 装货地址
    getStartArea(value) {
      this.searchForm.beginAreaCode = value[2];
    },
    // 卸货地址
    getEndArea(value) {
      this.searchForm.endAreaCode = value[2];
    },
    // 搜索
    handleSearch() {
      if (this.searchForm.begin.length == 0) {
        this.searchForm.beginAreaCode = "";
      }
      if (this.searchForm.end.length == 0) {
        this.searchForm.endAreaCode = "";
      }
      this.butLoading = true;
      this.init();
      setTimeout(() => {
        this.butLoading = false;
      }, 600);
    },
  },
};
</script>
<style scoped >
.Header-img {
  background-image: url("../assets/sourceInformation.png");
  width: 100%;
  height: 232px;
}
.search {
  background-color: #ffffff;
  margin-top: 40px;
  box-sizing: border-box;
  padding: 30px;
}
.search2 {
  border-top: 1px solid #f1f1f1;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 30px;
}
.search-span {
  color: #333;
  font-size: 14px;
  width: 100px;
  text-align: center;
  background: #f2f2f2;
  float: left;
  box-sizing: border-box;
  padding-top: 10px;
  margin-right: 10px;
  border-radius: 5px;
}
.search-span2 {
  color: #333;
  font-size: 14px;
  width: 100px;
  text-align: center;
  background: #f2f2f2;
  float: left;
  box-sizing: border-box;
  padding-top: 10px;
  height: 40px;
  margin-right: 10px;
  border-radius: 5px;
}
.Content-criteria {
  margin-left: 100px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #cccccc;
  cursor: pointer;
  transition: 0s;
}
.Content-tblo {
  width: 1090px;
  background-color: #ffffff;
  text-align: center;
}

/*     000000000000000000000000 */
.ivu-layout-header {
  padding: 0 !important;
  height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.ivu-menu-horizontal {
  height: 89px !important;
  line-height: 89px !important;
  background: #fff !important;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 19%) !important;
}
.layout {
  /* border: 1px solid #d7dde4; */
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  /* overflow: hidden; */
}
.ivu-layout-footer {
  padding: 0 !important;
}
.layout-logo {
  height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  float: left;
  position: relative;
  top: 30px;
  left: 30px;
}
.layout-logo img {
  height: 44px;
  position: relative;
}

.layout-nav {
  width: 725px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center {
  text-align: center;
}

.Footer-text-left {
  font-size: 40px;
  color: #065fc3;
  display: inline-block;
  font-style: italic;
  margin-left: 23%;
  margin-top: 45px;
}
.Footer-text-right {
  width: 321px;
  display: inline-block;
  margin-left: 96px;
  /* color: #ffffff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%); */
}
.Footer-text-title {
  font-size: 22px;
  margin-bottom: 10px;
  margin-left: -22px;
  color: #fff;
}
.opt {
  line-height: 2.2;
}
.opt-let {
  margin-left: -79px;
}
.opt-let2 {
  width: 400px;
  margin-left: -59px;
  display: inline-block;
}
.title {
  font-size: 16px;
  color: #b4c1cd;
  border-right: 1px #b4c1cd solid;
  padding-right: 15px;
}
.a-link {
  font-size: 16px;
  color: #ffffff;
  margin-left: 15px;
}
.a-link1 {
  font-size: 16px;
  color: #ffffff;
  margin-left: 14px;
}
.Line {
  margin-top: 40px;
  margin-bottom: 40px;
  /* border-bottom: 1px solid #fff; */
  z-index: 9999;
}
.LineClik {
  position: relative;
  bottom: 0px;
  left: 1px;
  width: 99.5%;
  height: 1px;
  background-color: #3f4955;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: rgb(33, 195, 143);
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/sourceInformation.vue